<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ filter(items, 'type', 'text')[0]?.value.text }}
    </div>
    <div class="grid grid-cols-2 gap-4">
      @for (prod of filter(items, 'type', 'product'); track prod) {
        <div class="border-solid border-[#cccccc] border-1 p-2">
          <img
            [src]="prod?.value?.image"
            class="rounded w-[100%] h-[150px] mb-3 object-cover" />
          <p
          [attr.style]="buildStyle('text', prod.styles?.headline)"
            class="font-bold m-0">
            {{ prod?.value?.headline }}
          </p>
          <p-divider></p-divider>
          <p
            class="m-0"
            [attr.style]="buildStyle('text', prod.styles?.description)" [innerHTML]="prod?.value?.description | lineBreak">
          </p>
          <div class="mt-3">
            <button
              pButton
              (click)="redirect(prod)"
              [attr.style]="buildStyle('button', prod.styles?.button)"
              class="!border-none w-[100%]">
              {{ prod?.value?.buttonLabel }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
